export const products = [
  {
    handle: "purple-leaf-ring",
    name: "Purple Leaf Ring",
    category: "Ring",
    description: "A delicate leaf-motif band in sterling silver with cubic zirconia detailing.",
    price: 1299,
    compareAt: 5299,
    tag: "Bestseller",
    image: "https://images.unsplash.com/photo-1589674781759-c21c37956a44?auto=format&fit=crop&w=1200&q=80",
  },
  {
    handle: "amethyst-wreath-studs",
    name: "Amethyst Wreath Studs",
    category: "Earrings",
    description: "Wreath-shaped stud earrings finished with faceted purple-toned stones.",
    price: 2499,
    compareAt: 5099,
    tag: null,
    image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&w=1200&q=80",
  },
  {
    handle: "violet-sparkle-pendant",
    name: "Violet Sparkle Pendant",
    category: "Pendant",
    description: "A sparkling gemstone pendant on a fine silver chain.",
    price: 1999,
    compareAt: 4399,
    tag: "New",
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&w=1200&q=80",
  },
  {
    handle: "lilac-name-necklace",
    name: "Lilac Name Necklace",
    category: "Necklace",
    description: "A customisable name necklace in a warm gold finish.",
    price: 2399,
    compareAt: 2599,
    tag: "Personalised",
    image: "https://images.unsplash.com/photo-1611107683227-e9060eccd846?auto=format&fit=crop&w=1200&q=80",
  },
  {
    handle: "orchid-solitaire-ring",
    name: "Orchid Solitaire Ring",
    category: "Ring",
    description: "A classic solitaire-style ring with a bold central stone.",
    price: 3999,
    compareAt: 8399,
    tag: "Bestseller",
    image: "https://images.unsplash.com/photo-1679156271420-e6c596e9c10a?auto=format&fit=crop&w=1200&q=80",
  },
  {
    handle: "zircon-fern-bracelet",
    name: "Zircon Fern Bracelet",
    category: "Bracelet",
    description: "A fern-inspired chain bracelet with sparkling stone accents.",
    price: 1999,
    compareAt: 3999,
    tag: null,
    image: "https://images.unsplash.com/photo-1679156271456-d6068c543ee7?auto=format&fit=crop&w=1200&q=80",
  },
  {
    handle: "iris-queen-necklace",
    name: "Iris Queen Necklace",
    category: "Necklace",
    description: "An elegant pendant necklace finished with a heart-shaped charm.",
    price: 1999,
    compareAt: 5799,
    tag: null,
    image: "https://images.unsplash.com/photo-1589128777073-263566ae5e4d?auto=format&fit=crop&w=1200&q=80",
  },
  {
    handle: "twilight-evil-eye-anklet",
    name: "Twilight Evil Eye Anklet",
    category: "Anklet",
    description: "A dainty anklet featuring an evil-eye charm for everyday wear.",
    price: 1499,
    compareAt: 2899,
    tag: "Bestseller",
    image: "https://images.unsplash.com/photo-1721206624492-3d05631471ea?auto=format&fit=crop&w=1200&q=80",
  },
];

export const inr = (n) => `₹${n.toLocaleString("en-IN")}`;
